import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		signedUser: {
			id: "",
			group_id: "",
			username: "",
			password: "",
			token: "",
			email: "",
			firstname: "",
			lastname: "",
			birthday: "",
			logo: "",
			date_register: "0",
			date_login: "0",
			total_login: "0",
			total_active_time: "0"
		}
	},
	mutations: {

	},
	actions: {

	}
})